/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import Insurance from "./Insurance";
import LoadingAlert from "./LoadingAlert";
import { SidebarGlobal } from "./_SidebarGlobal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from '@fortawesome/free-solid-svg-icons';
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import Alert from "./Alert";
import MessageDialog from "./MessageDialog";
import Globals from "../shared/Globals";
import { Pop } from "./PopModal";
import DocumentList from "./DocumentList";
import Prompt from "./Prompt";
import Auth from "../shared/Auth";
import Address from "./Address";
import React from "react";
import { v4 as uuidv4 } from 'uuid';
import { Dropdown, DropdownButton, Modal, Tab, Tabs } from "react-bootstrap";
import Rating from "./Rating";
import SendIVRModal from "./SendIVRModal";
import Icon from "./Icon";
import MedicalReleaseSendModal from "./MedicalReleaseSendModal";
import MedicalRelease from "./MedicalRelease";
import FormLabel from "./FormLabel";
import SendDocumentsModal from "./SendDocumentsModal";
import RequestFormList from "./requestform/RequestFormList";
import CommentList from "./CommentList";
import { ChatBubbleGlobal } from "./chat/ChatBubble";
import DiagCodeSelect from "./DiagCodeSelect";
import { Link } from "react-router-dom";
import AppActions from "./AppActions";
import Provider from "./Provider";

class ReferOutModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            organizations: []
        };
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        this.fillList('/api/organization/list', 'organizations', true);
    }

    submit(e) {
        e?.preventDefault();
        var orgID = this.state.info.referOutOrganizationID;
        if (!orgID)
            orgID = 0;
        qreq.post('/api/lead/refer/out/set', { id: this.props.lead.id, referOutOrganizationID: parseInt(orgID), isReferOut: true }, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else {
                this.success('Record has been referred out.');
                this.props.onSubmit?.();
            }
        }, this.unkownErrorCallback);
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title><L>Refer Out</L></Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    <p><L>Are you sure you want to refer this record out?</L></p>
                    <FormInput model={this.state.info} name="referOutOrganizationID" type="select" label="Organization" options={this.state.organizations} />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={this.props.onHide}><L>Cancel</L></button>
                    <button type="submit" className="btn btn-primary"><L>Refer Out</L></button>
                </Modal.Footer>
            </form>
        </Modal>
    }
}

class LeadsEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                hasPatient: false,
                patient: {
                    hasBirthDate: false,
                    address: {
                        country: 'USA'
                    }
                },
                referrer: {},
                wounds: [],
                insurances: [],
                documents: [],
                survey: {},
                woundTypes: [],
                cptCodes: [],
                account: {},
                provider: {}
            },
            comment: {},
            actionList: [],
            qualWoundSizes: [],
            woundTypes: [],
            userList: [],
            typeList: [],
            sourceList: [],
            accountList: [],
            providerList: [],
            productList: [],
            practiceList: [],
            woundTypes2: [
                'Diabetic Foot Ulcer',
                'Venous Leg Ulcer',
                'Pressure Ulcer',
                'Traumatic Burns',
                'Radiation Burns',
                'Dehisced Surgical Wound',
                'Necrotizing Fasciitis'
            ],
            selectedWoundTypes: {},
            cptCodes: [
                '15271',
                '15272',
                '15273',
                '15274',
                '15275',
                '15276',
                '15277',
                '15278'
            ],
            selectedCPTCodes: {},
            extra: {
                selectedWoundOther: false,
                woundTypesOther: ''
            },
            selectedWoundSizes: {},
            selectedWoundLengths: {},
            selectedWoundUnits: {},
            previousSelectedWoundUnits: {},
            units: [
                { id: 'cm', name: 'cm' },
                { id: 'in', name: 'in' }
            ],
            notesHeightOffset: 300,
            tab: 'basic',
            hash: uuidv4()
        };
        var qualWoundSizes = ['Dime', 'Nickel', 'Quarter', 'Golf Ball', 'Baseball', 'Other'];
        qualWoundSizes.forEach(i => {
            this.state.qualWoundSizes.push({ id: i, name: i });
        });
        var woundTypes = ['Diabetic', 'Pressure Ulcer/Bed Sore', 'Pressure Ulcer/Other', 'Puncture', 'Skin Tear', 'Venous Leg Ulcer', 'Other'];
        woundTypes.forEach(i => {
            this.state.woundTypes.push({ id: i, name: i });
        });
        this.genders = [{ id: 'M', name: 'Male' }, { id: 'F', name: 'Female' }, { id: 'U', name: 'Unknown' }];

        this.load = this.load.bind(this);
        this.loadTables = this.loadTables.bind(this);
        this.processItem = this.processItem.bind(this);
        this.setSubNav = this.setSubNav.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onLeadTypeChange = this.onLeadTypeChange.bind(this);
        this.onLeadSourceChange = this.onLeadSourceChange.bind(this);
        this.onAccountChange = this.onAccountChange.bind(this);
        this.submit = this.submit.bind(this);
        this.delete = this.delete.bind(this);
        this.convertToPatient = this.convertToPatient.bind(this);
        this.orderNextActionChanged = this.orderNextActionChanged.bind(this);
        this.readyToIVR = this.readyToIVR.bind(this);
        this.downloadIVR = this.downloadIVR.bind(this);
        this.setIVRSent = this.setIVRSent.bind(this);
        this.initSelectedWoundTypes = this.initSelectedWoundTypes.bind(this);
        this.initSelectedCPTCodes = this.initSelectedCPTCodes.bind(this);
        this.setDefaultLeadType = this.setDefaultLeadType.bind(this);
        this.tick = this.tick.bind(this);
        this.onSelectAccount = this.onSelectAccount.bind(this);
        this.requestSign = this.requestSign.bind(this);
        this.approveClinical = this.approveClinical.bind(this);
        this.declineClinical = this.declineClinical.bind(this);
        this.referOut = this.referOut.bind(this);
        this.setOnHold = this.setOnHold.bind(this);
        this.referOutApprove = this.referOutApprove.bind(this);
        this.loadApprovals = this.loadApprovals.bind(this);
        this.loadLatestComment = this.loadLatestComment.bind(this);
    }

    async componentDidMount() {
        await this.getSettings();
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        this.setSubNav();
        this.loadTables();
        this.load();
        ChatBubbleGlobal.setOrder(this.props.params.id);
        window.onbeforeunload = undefined;
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
        if (this.tickInterval)
            clearInterval(this.tickInterval);
        qreq.post('/api/order/unlock', { id: this.state.item.id });
        ChatBubbleGlobal.setOrder(null);
        window.onbeforeunload = undefined;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.item.orderNextActionID !== this.state.item.orderNextActionID) {
            this.orderNextActionChanged(this.state.item.orderNextActionID, true);
        }
        if (prevState.typeList !== this.state.typeList) {
            this.setDefaultLeadType();
        }
        if (prevState.item !== this.state.item && !this.state.item.leadTypeID) {
            this.setDefaultLeadType();
        }
        /*
        if (!prevState.item.id && !prevState.item.leadSourceID && prevState.sourceList.length !== 0) {
            var find = prevState.sourceList.find(a => a.isDefault === true);
            if (find) {
                this.setState({ item: { ...this.state.item, leadSourceID: find.id } });
            }
        }
        */
    }

    setSubNav(id) {
        if (!id) id = this.props.params.id;
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <button type="button" className="btn btn-success d-none d-md-inline-block" onClick={() => this.submit()}><FontAwesomeIcon icon={fa.faSave} /> <span className="d-none d-md-inline"><L>Save</L></span></button>
            {id && Auth.hasRole('manager') ? <button type="button" className="btn btn-secondary" onClick={() => this.convertToPatient()}><FontAwesomeIcon icon={fa.faPeopleArrows} /> <span className="d-none d-md-inline"><L>Convert to Patient</L></span></button> : ''}
            {id && Auth.hasRole('admin') ? <button type="button" className="btn btn-danger" onClick={() => this.delete()}><FontAwesomeIcon icon={fa.faTrash} /> <span className="d-none d-md-inline"><L>Delete</L></span></button> : ''}
        </div></>);
    }

    load(id) {
        if (!id)
            id = this.props.params.id;
        this.initSelectedWoundTypes();
        this.initSelectedCPTCodes();
        if (id) {
            qreq.get('/api/lead/get/' + id, j => {
                if (j.item) {
                    this.processItem(j.item);
                    j.item.woundTypes.forEach(i => {
                        if (this.state.selectedWoundTypes[i.name] !== true && this.state.selectedWoundTypes[i.name] !== false)
                            this.state.woundTypes2.push(i.name);
                        this.state.selectedWoundTypes[i.name] = true;
                        this.state.selectedWoundSizes[i.name] = i.woundSize;
                        this.state.selectedWoundWidths[i.name] = i.woundWidth;
                        this.state.selectedWoundLengths[i.name] = i.woundLength;
                        this.state.selectedWoundDepths[i.name] = i.woundDepth;
                        this.state.selectedWoundUnits[i.name] = 'cm';
                        this.state.previousSelectedWoundUnits[i.name] = 'cm';
                    });

                    j.item.cptCodes.forEach(i => {
                        this.state.selectedCPTCodes[i.code] = true;
                    });

                    this.setState({ item: j.item, loaded: true, locked: j.item.isLocked });

                    if (j.item.notesHeightOffset)
                        this.setState({ notesHeightOffset: j.item.notesHeightOffset });

                    if (!j.item.isLocked) {
                        this.tick(j.item.id);
                        this.tickInterval = setInterval(() => this.tick(), 10000);
                    }
                    this.loadApprovals(j.item.id);

                    window.onbeforeunload = undefined;

                    if (!j.item.isLead)
                        this.setState({ isPatient: true, locked: true });
                }
                else if (j.errorCode === 9) {
                    this.props.navigate('/order/view/' + id);
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
        else {
            Auth.getLogin(u => {
                if (u)
                    this.setState({ item: { ...this.state.item, assignedToUserID: u.id } });
            });
            this.setState({ loaded: true });
        }
    }

    loadTables() {
        qreq.get('/api/order/action/list', j => {
            if (j.list)
                this.setState({ actionList: j.list });
        });
        qreq.get('/api/lead/user/list', j => {
            if (j.list)
                this.setState({ userList: j.list });
        });
        qreq.get('/api/lead/type/list', j => {
            if (j.list) {
                j.list.push({ id: 0, name: 'Unclassified' });
                this.setState({ typeList: j.list });
            }
        });
        qreq.get('/api/lead/source/list', j => {
            if (j.list)
                this.setState({ sourceList: j.list });
        });
        qreq.get('/api/account/list', j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list)
                this.setState({ accountList: j.list });
        });
        qreq.post('/api/provider/list', {}, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list)
                this.setState({ providerList: j.list });
        });
        qreq.post('/api/product/list', {}, j => {
            if (j.list) {
                var products = [];
                var sizes = [];
                j.list.forEach(i => {
                    var product = products.find(k => k.id === i.qCode);
                    if (!product)
                        products.push({ id: i.qCode, name: i.name });
                    var size = sizes.find(k => k.id === i.name + '-' + i.productSize);
                    if (!size) {
                        sizes.push({ id: i.qCode, name: i.productSize, productName: i.name, productID: i.id });
                    }
                });
                this.setState({ productList: products });
            }
        });

        this.fillList('/api/practice/list', 'practiceList', true);
    }

    loadApprovals(id) {
        if (!id) id = this.state.item.id;

        qreq.get('/api/lead/service-approved/get?id=' + id, j => {
            if (j.item)
                this.setState({ serviceApprovedByUser: true });
            else
                this.setState({ serviceApprovedByUser: false });
        });

        qreq.get('/api/lead/clinical-approved/get?id=' + id, j => {
            if (j.item)
                this.setState({ clinicalApprovedByUser: true });
            else
                this.setState({ clinicalApprovedByUser: false });
        });

        qreq.get('/api/settings/get/public', j => {
            if (j.item) {
                this.setState({ settings: j.item });
                qreq.get('/api/lead/approvals/list?id=' + id, j => {
                    if (j.list)
                        this.setState({ approvals: j.list });
                    this.loadLatestComment(id);
                });
            }
        })

    }

    loadLatestComment(id) {
        if (!id) id = this.state.item.id;
        qreq.get('/api/comment/latest/order/' + id + '?isSystem=false', j => {
            if (j.item) {
                this.setState({ latestComment: j.item });
            }
        });
    }

    tick(id) {
        if (!id) id = this.state.item.id;
        if (id && !this.state.lockByUserID)
            qreq.post('/api/order/lock', { id: id });
    }

    setDefaultLeadType(item) {
        if (!item)
            item = this.state.item;
        if (item && !item.id && !item.leadType) {
            var def = this.state.typeList.find(a => a.isDefault === true);
            if (def)
                this.setState({ item: { ...item, leadTypeID: def.id } });
        }
    }

    initSelectedWoundTypes() {
        var obj = {};
        var obj2 = {};
        var obj3 = {};
        var obj4 = {};
        var obj5 = {};
        var obj6 = {};
        var obj7 = {};
        this.state.woundTypes2.forEach(i => {
            obj[i] = false;
            obj2[i] = 0;
            obj3[i] = 0;
            obj4[i] = 0;
            obj5[i] = 'cm';
            obj6[i] = 'cm';
            obj7[i] = 0;
        });
        this.setState({ selectedWoundTypes: obj, selectedWoundSizes: obj2, selectedWoundWidths: obj3, selectedWoundLengths: obj4, selectedWoundDepths: obj7, selectedWoundUnits: obj5, previousSelectedWoundUnits: obj6 });
    }

    initSelectedCPTCodes() {
        var obj = {};
        this.state.cptCodes.forEach(i => {
            obj[i] = false;
        });
        this.setState({ selectedCPTCodes: obj });
    }

    onAccountChange(obj) {
        this.onChange(obj);
    }

    processItem(item) {
        item.referrer._fullName = item.referrer.firstName;
        if (item.referrer.lastName)
            item.referrer._fullName += ' ' + item.referrer.lastName;
        item.survey = {};
        if (item.surveyJsonData) {
            try {
                item.survey = JSON.parse(item.surveyJsonData);
                if (!item.survey)
                    item.survey = {};
            }
            catch { }
        }
        if (item.survey.woundType && item.survey.woundType === 'Presure Ulcer/Bed Sore')
            item.survey.woundType = 'Pressure Ulcer/Bed Sore';
        return item;
    }

    onChange(v, nwl) {
        if (!nwl) {
            window.onbeforeunload = () => true;
            this.setState({ dirty: true });
        }

        var item = { ...this.state.item };
        var idx, find;

        if (!item.insurances)
            item.insurances = [];
        //Medicare
        if (item.survey.insuranceMedicare) {
            idx = item.insurances.findIndex(a => a.insuranceClass === 'Medicare' && !a.toRemove);
            if (idx < 0) {
                find = { key: uuidv4(), insuranceClass: 'Medicare', carrierName: 'Medicare', auto: true };
                item.insurances.push(find);
            }
            else {
                find = item.insurances[idx];
            }
            find.memberID = item.survey.insuranceMedicareMemberID;
            find.groupNumber = item.survey.insuranceMedicareGroupNumber;
            find.auto = true;
            item.insurances.splice(idx, 1, { ...find });
        }
        else {
            idx = item.insurances.findIndex(a => a.insuranceClass === 'Medicare' && !a.toRemove);
            if (idx >= 0)
                item.insurances.splice(idx, 1);
        }
        //Medicaid
        if (item.survey.insuranceMedicaid) {
            idx = item.insurances.findIndex(a => a.insuranceClass === 'Medicaid' && !a.toRemove);
            if (idx < 0) {
                find = { key: uuidv4(), insuranceClass: 'Medicaid', carrierName: 'Medicaid', auto: true };
                item.insurances.push(find);
            }
            else {
                find = item.insurances[idx];
            }
            find.memberID = item.survey.insuranceMedicaidMemberID;
            find.groupNumber = item.survey.insuranceMedicaidGroupNumber;
            find.auto = true;
            item.insurances.splice(idx, 1, { ...find });
        }
        else {
            idx = item.insurances.findIndex(a => a.insuranceClass === 'Medicaid' && !a.toRemove);
            if (idx >= 0)
                item.insurances.splice(idx, 1);
        }
        //MedicareReplacement
        var cname = 'Medicare Replacement Plan';
        var vname = 'MedicareReplacement';
        if (item.survey['insurance' + vname]) {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx < 0) {
                find = { key: uuidv4(), insuranceClass: cname, auto: true };
                item.insurances.push(find);
            }
            else {
                find = item.insurances[idx];
            }
            find.carrierName = item.survey['insurance' + vname + 'CarrierName'];
            find.memberID = item.survey['insurance' + vname + 'MemberID'];
            find.groupNumber = item.survey['insurance' + vname + 'GroupNumber'];
            find.auto = true;
            item.insurances.splice(idx, 1, { ...find });
        }
        else {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx >= 0)
                item.insurances.splice(idx, 1);
        }
        //HMO
        cname = 'HMO';
        vname = cname;
        if (item.survey['insurance' + vname]) {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx < 0) {
                find = { key: uuidv4(), insuranceClass: cname, auto: true };
                item.insurances.push(find);
            }
            else {
                find = item.insurances[idx];
            }
            find.carrierName = item.survey['insurance' + vname + 'CarrierName'];
            find.memberID = item.survey['insurance' + vname + 'MemberID'];
            find.groupNumber = item.survey['insurance' + vname + 'GroupNumber'];
            find.auto = true;
            item.insurances.splice(idx, 1, { ...find });
        }
        else {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx >= 0)
                item.insurances.splice(idx, 1);
        }
        //PPO
        cname = 'PPO';
        vname = cname;
        if (item.survey['insurance' + vname]) {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx < 0) {
                find = { key: uuidv4(), insuranceClass: cname, auto: true };
                item.insurances.push(find);
            }
            else {
                find = item.insurances[idx];
            }
            find.carrierName = item.survey['insurance' + vname + 'CarrierName'];
            find.memberID = item.survey['insurance' + vname + 'MemberID'];
            find.groupNumber = item.survey['insurance' + vname + 'GroupNumber'];
            find.auto = true;
            item.insurances.splice(idx, 1, { ...find });
        }
        else {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx >= 0)
                item.insurances.splice(idx, 1);
        }
        //Other
        cname = 'Supplemental';
        vname = 'Other';
        if (item.survey['insurance' + vname]) {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx < 0) {
                find = { key: uuidv4(), insuranceClass: cname, auto: true };
                item.insurances.push(find);
            }
            else {
                find = item.insurances[idx];
            }
            find.carrierName = item.survey['insurance' + vname + 'CarrierName'];
            find.memberID = item.survey['insurance' + vname + 'MemberID'];
            find.groupNumber = item.survey['insurance' + vname + 'GroupNumber'];
            find.auto = true;
            item.insurances.splice(idx, 1, { ...find });
        }
        else {
            idx = item.insurances.findIndex(a => a.insuranceClass === cname && !a.toRemove);
            if (idx >= 0)
                item.insurances.splice(idx, 1);
        }

        this.setState({ item: item });
    }

    onLeadTypeChange(v) {
        this.onChange(v);
    }

    onLeadSourceChange(v) {
        this.onChange(v);
    }

    orderNextActionChanged(vid, nwl) {
        if (this.state.actionList) {
            var find = this.state.actionList.find(a => a.id === Number(vid));
            if (find)
                this.setState({ orderNextAction: find });
            this.onChange(vid, nwl);
        }
    }

    convertToPatient(e) {
        if (e) e.preventDefault();
        Pop.showConfirm(<><L>Are you sure you want to convert this lead?</L></>, 'Convert to Patient', () => {
            this.submit(null, () => {
                this.setState({ saving: true });
                qreq.post('/api/lead/convert', { ...this.state.item }, j => {
                    if (j.item) {
                        this.success('Successfully converted to patient.');
                        this.props.navigate('/order/view/' + j.item.id + '?converted=true');
                    }
                    else
                        this.alert(j.errorMessage);
                    this.setState({ saving: false });
                }, () => {
                    this.unkownErrorCallback();
                    this.setState({ saving: false });
                });
            });
        });
    }

    readyToIVR() {
        if (this.state.item.patient.firstName && this.state.item.patient.lastName,
            this.state.item.patient.birthDate)
            return true;
        return false;
    }

    downloadIVR(ver) {
        this.submit(null, () => {
            window.open(Globals.serverUrl + '/api/document/render/ivr/' + this.state.item.id + (ver ? '/' + ver : ''));
        });
    }

    setIVRSent() {
        Pop.showConfirm('Are you sure you want to set this order to IVR Sent?', 'Set to IVR Sent', () => {
            qreq.post('/api/order/status/set', { ...this.state.item, status: 'IVR Sent' }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item) {
                    this.setState({ item: { ...this.state.item, status: j.item.status } });
                    this.submit(null, () => this.load(), 'Await IVR Approval');
                }
            });
        });
    }

    delete() {
        Pop.showConfirm('Are you sure you want to permanently delete this record?', 'Delete Record', () => {
            qreq.post('/api/lead/delete', { ...this.state.item }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.success('Item has been deleted!');
                    this.props.navigate('/lead');
                }
            }, this.unkownErrorCallback);
        });
    }

    requestSign() {
        Pop.showConfirm('Are you sure you want to request a signature for this patient?', 'Request Signature', () => {
            this.setState({ requesting: true });
            qreq.post('/api/document/sign/request', { orderID: this.state.item.id }, j => {
                if (j.errorCode === 0) {
                    this.success('Signature request sent.');
                }
                else
                    this.alert(j.errorMessage);
                this.setState({ requesting: false });
            }, () => {
                this.unkownErrorCallback();
                this.setState({ requesting: false });
            });
        });
    }

    submit(e, successCallback, nextAction) {
        if (e) e.preventDefault();
        var item = { ...this.state.item };

        if (!item.orderNextActionID)
            item.orderNextActionID = 0;

        var name = item.referrer._fullName;
        if (!name && !item.patient.firstName && !item.patient.lastName) {
            this.alert('Please fill in a referrer full name/alias or a patient name.');
            return;
        }

        if (!name)
            name = '';

        if (name.indexOf(' ') >= 0) {
            var p = name.split(' ');
            if (p.length > 1) {
                item.referrer.firstName = p[0];
                item.referrer.lastName = name.substr(p[0].length + 1);
            }
            else {
                item.referrer.firstName = name;
                item.referrer.lastName = '';
            }
        }
        else {
            item.referrer.firstName = name;
            item.referrer.lastName = '';
        }

        if (this.state.extra.woundTypesOther && this.state.extra.woundTypesOther.trim()) {
            var p = this.state.extra.woundTypesOther.split(',');
            p.forEach(i => {
                this.state.item.woundTypes.push({ name: i.trim(), woundSize: '' });
            });
        }

        if (!item.provider?.id) {
            item.provider = { id: 0 };
        }

        var originalWoundTypes = [...item.woundTypes];
        item.woundTypes = [];
        for (var k in this.state.selectedWoundTypes) {
            if (this.state.selectedWoundTypes[k]) {
                var w = Number(this.state.selectedWoundWidths[k] ?? 0);
                var l = Number(this.state.selectedWoundLengths[k] ?? 0);
                var wd = Number(this.state.selectedWoundDepths[k] ?? 0);
                if (this.state.selectedWoundUnits[k] === 'in') {
                    w = w * 2.54;
                    l = l * 2.54;
                }
                item.woundTypes.push({ name: k, woundSize: String(this.state.selectedWoundSizes[k] ?? ''), woundWidth: w, woundLength: l, woundDepth: wd });
            }
            else {
                // eslint-disable-next-line no-loop-func
                originalWoundTypes.forEach(i => {
                    if (i.name === k) {
                        i.toRemove = true;
                        this.state.item.woundTypes.push(i);
                    }
                });
            }
        }

        if (this.state.extra.woundTypesOther && this.state.extra.woundTypesOther.trim()) {
            var p = this.state.extra.woundTypesOther.split(',');
            p.forEach(i => {
                item.woundTypes.push({ name: i.trim(), woundSize: '' });
            });
        }

        var originalCPTCodes = [...this.state.item.cptCodes];
        item.cptCodes = [];
        for (var kk in this.state.selectedCPTCodes) {
            if (this.state.selectedCPTCodes[kk])
                item.cptCodes.push({ code: kk });
            else {
                // eslint-disable-next-line no-loop-func
                originalCPTCodes.forEach(i => {
                    if (i.code === kk) {
                        i.toRemove = true;
                        item.cptCodes.push(i);
                    }
                });
            }
        }

        item.surveyJsonData = JSON.stringify(item.survey);

        if (item.patient && item.patient.birthDate) {
            try {
                var d = new Date(item.patient.birthDate);
                item.patient.birthDate = Globals.toMDYDateString(d);
            }
            catch { }
        }

        if (nextAction) {
            var find = this.state.actionList.find(a => a.name === nextAction);
            if (find)
                item.orderNextActionID = find.id;
        }

        this.onSubmitComment(null, true);

        this.setState({ saving: true });
        qreq.post('/api/lead/save', item, j => {
            if (j.item) {
                if (!successCallback)
                    this.success('Lead information has been saved.');
                this.setState({ item: this.processItem(j.item), dirty: false });
                this.onChange();
                window.onbeforeunload = undefined;
                if (this.state.item.id !== j.item.id) {
                    this.props.navigate('/lead/edit/' + j.item.id);
                    this.setSubNav(j.item.id);
                    this.load(j.item.id);
                }
                if (successCallback)
                    successCallback();
                if (!this.tickInterval) {
                    this.tick(j.item.id);
                    this.tickInterval = setInterval(() => this.tick(), 10000);
                }
            }
            else
                this.alert(j.errorMessage);
            this.setState({ saving: false });
        }, () => {
            this.unkownErrorCallback()
            this.setState({ saving: false });
        });
    }

    onSelectAccount(obj, name) {
        console.log(name, obj);
    }

    approveService(set) {
        Pop.showConfirm(!set ? 'Are you sure you want to rollback?' : 'Are you sure you want to set this order as Service Approved?', 'Service Approval', () => {
            qreq.post('/api/lead/service-approved/set', { ...this.state.item, isServiceApproved: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item) {
                    this.setState({ item: { ...this.state.item, isServiceApproved: j.item.isServiceApproved, isServiceDeclined: false } });
                    if (set) {
                        this.success('Successfully set as Service Approved.');
                        this.submit(null, () => { });
                    }
                    else
                        this.success('Successful rollback.');
                    this.loadApprovals();
                }
            }, this.unkownErrorCallback);
        });
    }

    declineService(set) {
        Pop.showConfirm('Are you sure you want to set this order as Service Declined?', 'Service Declined', () => {
            qreq.post('/api/lead/service-declined/set', { ...this.state.item, isServiceDeclined: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item) {
                    this.setState({ item: { ...this.state.item, isServiceDeclined: j.item.isServiceDeclined, isServiceApproved: false } });
                    if (set)
                        this.success('Successfully set as Service Declined.');
                    else
                        this.success('Successful rollback.');
                    this.loadApprovals();
                }
            }, this.unkownErrorCallback);
        });
    }

    approveClinical(set) {
        Pop.showConfirm(!set ? 'Are you sure you want to rollback?' : 'Are you sure you want to set this order as Clinical Approved?', 'Clinical Approval', () => {
            qreq.post('/api/lead/clinical-approved/set', { ...this.state.item, isClinicalApproved: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item) {
                    this.setState({ item: { ...this.state.item, isClinicalApproved: j.item.isClinicalApproved, isClinicalDeclined: false } });
                    if (set)
                        this.success('Successfully set as Clinical Approved.');
                    else
                        this.success('Successful rollback.');
                    this.loadApprovals();
                }
            }, this.unkownErrorCallback);
        });
    }

    declineClinical(set) {
        Pop.showConfirm('Are you sure you want to set this order as Clinical Declined?', 'Clinical Declined', () => {
            qreq.post('/api/lead/clinical-declined/set', { ...this.state.item, isClinicalDeclined: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item) {
                    this.setState({ item: { ...this.state.item, isClinicalDeclined: j.item.isClinicalDeclined, isClinicalApproved: false } });
                    if (set)
                        this.success('Successfully set as Clinical Declined.');
                    else
                        this.success('Successful rollback.');
                    this.loadApprovals();
                }
            }, this.unkownErrorCallback);
        });
    }

    setOnHold(set) {
        Pop.showConfirm(set ? 'Are you sure you want to put this record on hold?' : 'Are you sure you want this record taken off hold?', 'On Hold', () => {
            qreq.post('/api/lead/on-hold/set', { ...this.state.item, isOnHold: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.success(set ? 'Record has been put on hold.' : 'Record has been taken off hold.');
                    this.goBack();
                }
            }, this.unkownErrorCallback);
        });
    }

    setDeclined(set) {
        Pop.showConfirm(set ? 'Are you sure you want to decline this record?' : 'Are you sure you want this record taken off decline?', 'Decline', () => {
            qreq.post('/api/lead/declined/set', { ...this.state.item, isDeclined: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.success(set ? 'Record has been declined.' : 'Record has been taken from declined.');
                    this.goBack();
                }
            }, this.unkownErrorCallback);
        });
    }

    setNotQualified(set) {
        Pop.showConfirm(set ? 'Are you sure you want to set this record as not qualified?' : 'Are you sure you want this record taken off from not qualified?', 'Not Qualified', () => {
            qreq.post('/api/lead/not-qualified/set', { ...this.state.item, isNotQualified: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.success(set ? 'Record has been set as not qualified.' : 'Record has been taken from not qualified.');
                    this.goBack();
                }
            }, this.unkownErrorCallback);
        });
    }

    setActive() {
        Pop.showConfirm('Are you sure you want to set this record as active?', 'Active', () => {
            qreq.post('/api/lead/active/set', { ...this.state.item }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.success('Record has been set as active.');
                    this.goBack();
                }
            }, this.unkownErrorCallback);
        });
    }

    referOut(set) {
        if (set) {
            this.setState({ showReferOutModal: true });
            return;
        }
        Pop.showConfirm(set ? 'Are you sure you want to refer this record out?' : 'Are you sure you want to claim this record? (Remove from Refer Out)', 'Refer Out', () => {
            qreq.post('/api/lead/refer/out/set', { ...this.state.item, isReferOut: set }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.success(set ? 'Record has been referred out.' : 'Record has been claimed.');
                    this.goBack();
                }
            }, this.unkownErrorCallback);
        });
    }

    referOutApprove() {
        Pop.showConfirm('Are you sure you want to approve this record?', 'Approve Refer Out', () => {
            qreq.post('/api/lead/refer/out/approve', { ...this.state.item }, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else {
                    this.success('Record has been approved for referral.');
                    this.goBack();
                }
            }, this.unkownErrorCallback);
        });
    }

    onSubmitComment(e, noFeedback) {
        e?.preventDefault();
        var comment = { ...this.state.comment };
        if (!comment.message || comment.message.trim() === '') {
            if (!noFeedback)
                this.alert('Please enter a comment.');
            return;
        }
        comment.orderId = this.state.item.id;
        qreq.post('/api/comment/post', comment, j => {
            if (j.errorCode === 0) {
                this.setState({ comment: {} });
                if (!noFeedback)
                    this.success('Your comment has been posted below.');
                this.loadLatestComment();
                this.setState({ hash: uuidv4() });
            }
            else {
                if (!noFeedback)
                    this.alert(j.errorMessage);
            }
        });
    }

    render() {
        const header = (<>
            <h1 className="fixed"><strong>{this.state.item?.patient?.lastName}, {this.state.item?.patient?.firstName}</strong> #{this.state.item?.oid} (<span className="d-inline d-md-none text-muted"><L>Q</L></span><span className="d-none d-md-inline text-muted"><L>Queue</L></span>)</h1>
        </>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        // <Prompt when={this.state.dirty && !this.state.saving} message="There are unsaved changes. Are you sure you want to leave?" />


        var swt_f = () => {
            var c = 0;
            for (var k in this.state.selectedWoundTypes) {
                if (this.state.selectedWoundTypes[k])
                    c++;
            }
            if (c === 0)
                return <Alert message="There are no wound types selected." />;
            else
                return '';
        };

        var scc_f = () => {
            var c = 0;
            for (var k in this.state.selectedCPTCodes) {
                if (this.state.selectedCPTCodes[k])
                    c++;
            }
            if (c === 0)
                return <Alert message="There are no CPT Codes selected." />;
            else
                return '';
        };

        if (this.state.locked)
            SidebarGlobal.clearSubNav();

        return <div className="LeadEdit container-fluid">
            <ReferOutModal lead={this.state.item} show={this.state.showReferOutModal} onSubmit={() => { this.setState({ showReferOutModal: false }); this.goBack(); }} onHide={() => this.setState({ showReferOutModal: false })} />
            <div className="p-4"></div>

            {header}
            <SendIVRModal item={this.state.item} show={this.state.showSendIVR} onHide={() => { this.setState({ showSendIVR: false }); this.load(); }} onSend={callback => {
                this.submit(null, () => {
                    callback();
                });
            }} />
            <SendDocumentsModal item={this.state.item} show={this.state.showSendDocumentsModal} onHide={() => { this.setState({ showSendDocumentsModal: false }); this.load(); }} onSend={callback => callback()} />

            <div className="d-flex align-items-center mb-2 after-h1-fixed">
                <div className="flex-fill">
                </div>
                <div>
                    <Rating rating={this.state.item.rating} onChange={!this.state.locked ? v => this.setState({ item: { ...this.state.item, rating: v } }) : null} brief />
                </div>
            </div>
            {this.state.locked && !this.state.isPatient ? <Card title="Locked">
                <p>This record is currently locked by: <strong>{this.state.item.lockByUserName}</strong></p>
            </Card> : ''}
            {this.state.isPatient && <Alert>
                This record has already been converted to a patient: <Link to={`/order/view/${this.state.item?.id}`}>{this.state.item?.patient?.firstName} {this.state.item?.patient?.lastName} <i>(click here to return to the patient record)</i></Link>
            </Alert>}
            <form onSubmit={this.submit}>
                <AppActions>
                    <div className="d-flex justify-content-end gap-1">
                        {Auth.hasRole('manager') &&
                            <DropdownButton title="Actions" size="lg" drop="up" className="has-icons">
                                {this.state.item.isLead && !this.state.item.isReferOut && !this.state.item.isNotQualified && <Dropdown.Item onClick={() => this.setNotQualified(true)}><Icon icon="faTimes" /> <L>Not Qualified</L></Dropdown.Item>}
                                {this.state.item.isLead && !this.state.item.isReferOut && !this.state.item.isDeclined && <Dropdown.Item onClick={() => this.setDeclined(true)}><Icon icon="faCancel" /> <L>Declined</L></Dropdown.Item>}
                                {this.state.item.isLead && !this.state.item.isReferOut && !this.state.item.isOnHold && <Dropdown.Item onClick={() => this.setOnHold(true)}><Icon icon="faStop" /> <L>On Hold</L></Dropdown.Item>}
                                {this.state.item.isLead && !this.state.item.isReferOut && (this.state.item.isOnHold || this.state.item.isDeclined || this.state.item.isNotQualified) && <Dropdown.Item onClick={() => this.setActive()}><Icon icon="faPlay" /> <L>Back to Active Record</L></Dropdown.Item>}
                                {this.state.item.isLead && !this.state.item.isReferOut && <Dropdown.Item onClick={() => this.referOut(true)}><Icon icon="faPersonHiking" /> <L>Refer Out</L></Dropdown.Item>}
                                {this.state.item.isLead && this.state.item.isReferOut && this.state.item.isReferPending && <Dropdown.Item onClick={() => this.referOutApprove()}><Icon icon="faCheck" /> <L>Approve Referral</L></Dropdown.Item>}
                                {this.state.item.isLead && this.state.item.isReferOut && <Dropdown.Item onClick={() => this.referOut(false)}><Icon icon="faHandshakeAngle" /> <L>Claim</L></Dropdown.Item>}
                                {Auth.hasRole('admin') && <Dropdown.Item onClick={() => this.setState({ showSendDocumentsModal: true })}><Icon icon="faShare" /> <L>Share Documents</L></Dropdown.Item>}
                                {!this.state.item.isLead && <>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={() => this.props.navigate(`/order/view/${this.state.item?.id}`)}><Icon icon="faInfo" /> <L>View Patient Record</L></Dropdown.Item>
                                </>}
                            </DropdownButton>}
                        <button type="submit" className="btn btn-success btn-lg">
                            <Icon icon="faSave" /> <L>Save</L>
                        </button>
                    </div>
                </AppActions>
                <Tabs
                    activeKey={this.state.tab}
                    defaultActiveKey="basic"
                    onSelect={(k) => { this.setState({ tab: k }); }}
                    id="c-lead-tabs"
                    className="app-tabs"
                    animation="false">
                    <Tab eventKey="basic" title="Basic/Patient">
                        {!this.state.item.isReferOut && this.state.item.id && <Card title="Checklist">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <span className="d-inline-block ms-2">Service Approval ({this.state.approvals?.filter(a => a.approvalType === 1).length}/{this.state.settings?.serviceApprovalsRequired})</span>
                                        <ul className="list-group">
                                            {this.state.approvals?.filter(a => a.approvalType === 1).map((i, idx) => <li key={idx} className="list-group-item">{i.isApproved ? <Icon icon="faCheck" className="text-success" /> : <Icon icon="faTimes" className="text-danger" />} <strong>{i.approvedByUserName}</strong> - {Globals.toMDYHMLocalDateString(i.createdDate)}</li>)}
                                        </ul>
                                        <div className="my-3">
                                            <FormInput disabled={this.state.locked || !this.state.user?.hasServiceApproval} model={this.state.item.provider} name="id" label="Billing Provider" type="select" options={this.state.providerList} onChange={this.onChange} />
                                        </div>
                                        {this.state.item.isLead && <>
                                            {this.state.user?.hasServiceApproval && <>
                                                {this.state.serviceApprovedByUser ? <div className="mt-3">
                                                    <button type="button" className="btn btn-secondary" onClick={() => this.approveService(false)}>Rollback to Service Pending</button>
                                                </div> : <div className="mt-3">
                                                    <button type="button" className="btn btn-success" onClick={() => this.approveService(true)}><Icon icon="faCheck" /> <L>Set as Service Approved</L></button>
                                                    <button type="button" className="btn btn-danger" onClick={() => this.declineService(true)}><Icon icon="faTimes" /> <L>Set as Service Declined</L></button>
                                                </div>}
                                            </>}
                                        </>}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <span className="d-inline-block ms-2">Clinical Approval ({this.state.approvals?.filter(a => a.approvalType === 2).length}/{this.state.settings?.clinicalApprovalsRequired})</span>
                                        <ul className="list-group">
                                            {this.state.approvals?.filter(a => a.approvalType === 2).map((i, idx) => <li key={idx} className="list-group-item">{i.isApproved ? <Icon icon="faCheck" className="text-success" /> : <Icon icon="faTimes" className="text-danger" />} <strong>{i.approvedByUserName}</strong> - {Globals.toMDYHMLocalDateString(i.createdDate)}</li>)}
                                        </ul>
                                        {this.state.item.isLead && <>
                                            {this.state.user?.hasClinicalApproval && (!this.state.item.isServiceApproved ? <>
                                                <p className="mt-3"><i><L>To initiate the clinical approval process this record must be service approved first.</L></i></p>
                                            </> : <>
                                                {this.state.clinicalApprovedByUser ? <div className="mt-3">
                                                    <button type="button" className="btn btn-secondary" onClick={() => this.approveClinical(false)}>Rollback to Clinical Pending</button>
                                                </div> : <div className="mt-3">
                                                    <button type="button" className="btn btn-success" onClick={() => this.approveClinical(true)}><Icon icon="faCheck" /> <L>Set as Clinical Approved</L></button>
                                                    <button type="button" className="btn btn-danger" onClick={() => this.declineClinical(true)}><Icon icon="faTimes" /> <L>Set as Clinical Declined</L></button>
                                                </div>}
                                            </>
                                            )}
                                        </>}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <span className="d-inline-block">
                                        {this.state.item.isIVRApproved ? <Icon icon="faCheck" color="green" /> : this.state.item.isIVRDeclined ? <Icon icon="faTimes" color="red" /> : <Icon icon="faCircleQuestion" color="gray" />}
                                    </span>
                                    <span className="d-inline-block ms-2"><L>Insurance Approval</L></span>
                                    {!this.state.item.isIVRApproved && !this.state.item.isIVRDeclined && <div className="mt-3">
                                        <small className="text-secondary">For IVR Approval please upload a document with the IVR Result - information (Ex. a word document with a copy of the email response) to the Documents tab.</small>
                                    </div>}
                                </div>
                            </div>
                        </Card>}
                        <Card title="Summary" headerButtons={<span>Created On: <strong>{Globals.toMDYHMLocalDateString(this.state.item.leadDate)}</strong></span>}>
                            <div className="row">
                                <div className="col-md-4">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Referring Partner" name="referringAccountID" type="select-search" options={this.state.accountList} />
                                </div>
                                <div className="col-md-4">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Facility Type" name="leadSourceID" type="select" options={this.state.sourceList} onChange={this.onLeadSourceChange} />
                                </div>
                                <div className="col-md-4">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Facility Name" name="facilityName" type="text" onChange={this.onChange} />
                                </div>
                            </div>

                            <FormInput
                                disabled={this.state.locked}
                                model={this.state.item}
                                label="Care Coordinator"
                                name="salesRepUserID"
                                type="select"
                                options={this.state.userList.filter(a => a.isSalesRep)}
                                onChange={this.onChange}
                            />

                            <FormInput model={this.state.comment} name="message" label="Note" type="textarea" rows={5} placeholder="Write a note here..." onChange={this.onChange} disabled={this.state.locked} />
                            <div className="btn-group">
                                <button type="button" className="btn btn-primary" disabled={!this.state.comment.message} onClick={() => this.onSubmitComment()}>Submit Note</button>
                            </div>
                            <small className="ms-3 text-muted"><L>Saving the lead also saves the notes.</L></small>

                            {this.state.latestComment ? <div className="my-3">
                                <label className="form-label"><L>Last Note</L><i className="text-primary">{this.state.latestComment.createdByUserName}</i> <span className="text-muted">{Globals.toMDYHMLocalDateStringOrDiff(this.state.latestComment.createdDate, true)}</span></label>
                                <div className="p-2 bg-white">
                                    {this.state.latestComment.message}
                                </div>
                            </div> : <p><L>No notes created.</L></p>}

                            {this.state.item.notes && <div className="my-3">
                                <label className="form-label"><L>Legacy Notes</L></label>
                                <div className="p-2 bg-white">
                                    {this.state.item.notes}
                                </div>
                                <small className="text-muted"><L>These are notes that where created before the new notes system.</L></small>
                            </div>}

                            <div className="mb-3">
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ tab: 'notes' })}>View All Notes</button>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Next Action" name="orderNextActionID" type="select" options={this.state.actionList} selectDefault="Don't Know Yet" onChange={this.orderNextActionChanged} />
                                </div>
                                {this.state.orderNextAction && this.state.orderNextAction.isTrash ? <div className="col-md-3">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Discard Reason" name="orderNextActionDiscardReason" type="text" onChange={this.onChange} />
                                </div> : ''}
                                {this.state.orderNextAction && this.state.orderNextAction.name === 'Follow Up Contact Name' ? <div className="col-md-3">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Referring Staff Contact Name" name="orderNextActionStaffName" type="text" onChange={this.onChange} />
                                </div> : ''}
                                <div className="col-md-3">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Referring Staff Contact Name" name="orderNextActionNotes" type="text" onChange={this.onChange} />
                                </div>
                            </div>
                        </Card>
                        {Auth.hasRole('manager') ? <Card title="Assignment">
                            <div className="row">
                                <div className="col-md-6">
                                    <FormInput disabled={this.state.locked} model={this.state.item} label="Assign To" name="assignedToUserID" type="select" options={this.state.userList} onChange={this.onChange} />
                                </div>
                            </div>
                        </Card> : null}
                        <Card title="Caller Information">
                            <div className="row">
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.referrer} label="Full Name or Alias" name="_fullName" type="text" onChange={this.onChange} />
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.referrer} label="Phone Number" name="phone" type="tel" onChange={this.onChange} />
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.referrer} label="Email" name="email" type="email" onChange={this.onChange} />
                                </div>
                            </div>
                        </Card>
                        <Card title="Patient Information">
                            <div className="row">
                                <div className="col-6">
                                    <FormInput disabled={this.state.locked} model={this.state.item.patient} label="First Name" name="firstName" type="text" onChange={this.onChange} />
                                </div>
                                <div className="col-6">
                                    <FormInput disabled={this.state.locked} model={this.state.item.patient} label="Last Name" name="lastName" type="text" onChange={this.onChange} />
                                </div>
                                <div className="col-md-6">
                                    <div className="d-flex">
                                        <label className="form-label d-block"><L>Date of Birth</L></label>
                                        <div className="ms-3" style={{ marginBottom: '-10px' }}>
                                            <FormInput disabled={this.state.locked} model={this.state.item.patient} label="I have birth date information." name="hasBirthDate" type="switch" onChange={v => this.setState({ item: { ...this.state.item, patient: { ...this.state.item.patient, hasBirthDate: v } } })} />
                                        </div>
                                    </div>
                                    {this.state.item.patient.hasBirthDate ? <FormInput disabled={this.state.locked} model={this.state.item.patient} label="" labelAsPlaceholder name="birthDate" type="dateselect" onChange={this.onChange} /> : ''}
                                </div>
                                <div className="col-md-6">
                                    <FormInput disabled={this.state.locked} model={this.state.item.patient} label="Gender" name="gender" type="select" options={this.genders} onChange={this.onChange} />
                                </div>
                            </div>
                        </Card>
                        <Card title={'Patient Demographics Contact'}>
                            <div className="row">
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.patient} name="phone" label="Phone" type="text" onChange={this.onChange} />
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.patient} name="phoneRel" label="Relationship" type="select" onChange={this.onChange} options={[
                                        { id: 'Self', name: 'Self' },
                                        { id: 'Spouse', name: 'Spouse' },
                                        { id: 'Parent', name: 'Parent' },
                                        { id: 'Son', name: 'Son' },
                                        { id: 'Daughter', name: 'Daughter' },
                                        { id: 'Other', name: 'Other' }
                                    ]} />
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.patient} label="Email" name="email" type="email" onChange={this.onChange} />
                                </div>
                            </div>
                        </Card>
                        {this.state.item.patient.firstName || this.state.item.patient.lastName || this.state.item.patient.birthDate ? <><Address typeSelect readOnly={this.state.locked} title="Patient Address" item={this.state.item.patient.address} onChange={this.onChange} />
                            <Card title="Place of Service Settings">
                                <FormInput disabled={this.state.locked} type="switch" model={this.state.item} name="usePatientAddressAsFacility" label="Use Patient Address as Facility in IVR" />
                            </Card>

                        </> : ''}
                    </Tab>
                    <Tab eventKey="notes" title="Notes">
                        <CommentList isLead isSystem={false} orderId={this.state.item.id} noForm hash={this.state.hash} />
                        {this.state.item.notes && <Card title="Legacy Notes">
                            <div className="p-2 bg-white" dangerouslySetInnerHTML={{ __html: this.processComment(this.state.item.notes) }}></div>
                            <small className="text-muted"><L>These are notes that where created before the new notes system.</L></small>
                        </Card>}
                    </Tab>
                    <Tab eventKey="insurance" title="Insurance">
                        <div className="row">
                            <div className="col-md">
                                <Card title="Insurance Overview">
                                    <div className="row">
                                        <div className="col-md">
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Traditional Medicare" name="insuranceMedicare" type="switch" onChange={v => { this.onChange(v); if (v) this.setState({ item: { ...this.state.item, rating: 3 } }); }} />
                                                {this.state.item.survey.insuranceMedicare ? <><FormInput disabled={this.state.locked} model={this.state.item.survey} label="Member ID" name="insuranceMedicareMemberID" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Group Number" name="insuranceMedicareGroupNumber" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" /></> : ''}
                                            </div>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Medicaid" name="insuranceMedicaid" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.insuranceMedicaid ? <><FormInput disabled={this.state.locked} model={this.state.item.survey} label="Member ID" name="insuranceMedicaidMemberID" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Group Number" name="insuranceMedicaidGroupNumber" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" /></> : ''}
                                            </div>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Medicare Replacement Plan" name="insuranceMedicareReplacement" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.insuranceMedicareReplacement ? <><FormInput disabled={this.state.locked} model={this.state.item.survey} label="Carrier Name" name="insuranceMedicareReplacementCarrierName" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Member ID" name="insuranceMedicareReplacementMemberID" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Group Number" name="insuranceMedicareReplacementGroupNumber" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" /></> : ''}
                                            </div>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="PPO" name="insurancePPO" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.insurancePPO ? <><FormInput disabled={this.state.locked} model={this.state.item.survey} label="Carrier Name" name="insurancePPOCarrierName" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Member ID" name="insurancePPOMemberID" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Group Number" name="insurancePPOGroupNumber" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" /></> : ''}
                                            </div>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="HMO" name="insuranceHMO" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.insuranceHMO ? <><FormInput disabled={this.state.locked} model={this.state.item.survey} label="Carrier Name" name="insuranceHMOCarrierName" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Member ID" name="insuranceHMOMemberID" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Group Number" name="insuranceHMOGroupNumber" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" /></> : ''}
                                            </div>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Supplemental" name="insuranceOther" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.insuranceOther ? <><FormInput disabled={this.state.locked} model={this.state.item.survey} label="Carrier Name" name="insuranceOtherCarrierName" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Member ID" name="insuranceOtherMemberID" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" />
                                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Group Number" name="insuranceOtherGroupNumber" type="text" onChange={this.onChange} labelAsPlaceholder inputGroupClassName="mb-3 ms-2" /></> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="col-md d-none">
                                <Card title="Care Status">
                                    <div className="row">
                                        <div className="col-md">
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Home Health" name="careStatusHomeHealth" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.careStatusHomeHealth ? <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="careStatusHomeHealthInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 ms-2" /> : ''}
                                            </div>
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Hospice" name="careStatusHospice" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="SNF/Rehab" name="careStatusSNF" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="PCP" name="careStatusPCP" type="switch" onChange={this.onChange} />
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Other" name="careStatusOther" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.careStatusOther ? <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Other" name="careStatusOtherInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 ms-2" /> : ''}
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>

                        {this.state.item.insurances.map(obj => <div key={obj.id ?? obj.key}>{!obj.toRemove ? <Insurance item={obj} edit={!this.state.locked} remove={i => { i.toRemove = true; this.onChange(); this.setState({ item: this.state.item }); }} onChange={this.onChange} /> : ''}</div>)}
                        <div className="bg-light mb-3">
                            <div className="btn-group p-3">
                                <button disabled={this.state.locked} type="button" className="btn btn-primary" onClick={() => this.addToList(this.state.item.insurances, {})} ><FontAwesomeIcon icon={fa.faPlus} /> Add {this.state.item.insurances.length === 0 ? 'First' : 'Another'} Insurance Information</button>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="codes" title="Codes">
                        <DiagCodeSelect item={this.state.item} onChange={this.onChange} disabled={this.state.locked} />
                    </Tab>
                    <Tab eventKey="provider" title="Provider">
                        <Provider title="Referring Provider" item={this.state.item.referringProvider} onChange={this.onChange} disabled={this.state.locked} />
                    </Tab>
                    {this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <Tab eventKey="wound" title="Wounds">
                        <Card title="Wound Information">
                            <div className="row">
                                <div className="col-md-6">
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="How did you get the wound?" name="woundReason" type="text" onChange={this.onChange} />
                                </div>
                                <div className="col-md-6">

                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="How long have you had the wound?" name="woundLife" type="select" options={[
                                        { id: '1 week or less', name: '1 week or less' },
                                        { id: '1-2 weeks', name: '1-2 weeks' },
                                        { id: '2-3 weeks', name: '2-3 weeks' },
                                        { id: 'More than 4 weeks', name: 'More than 4 weeks' }
                                    ]} onChange={this.onChange} />
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" labelAsPlaceholder name="woundTime" type="text" onChange={this.onChange} />
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Wound location?" name="woundLocation" type="text" onChange={this.onChange} />
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Wound size?" name="woundSize" type="select" options={this.state.qualWoundSizes} onChange={this.onChange} />
                                    {this.state.item.survey.woundSize === 'Other' ? <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Other size..." name="woundSizeOther" type="text" labelAsPlaceholder onChange={this.onChange} /> : ''}
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Wound depth?" name="woundDepth" labelAsPlaceholder type="select" options={[
                                        { id: 'Paper', name: 'Paper' },
                                        { id: 'Nickel', name: 'Nickel' },
                                        { id: 'Fingernail', name: 'Fingernail' },
                                        { id: '.50 Cal Bullet', name: '.50 Cal Bullet' },
                                        { id: 'Other', name: 'Other' }
                                    ]} onChange={this.onChange} />
                                    {this.state.item.survey.woundDepth === 'Other' ? <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Other depth..." name="woundDepthOther" type="text" labelAsPlaceholder onChange={this.onChange} /> : ''}
                                </div>
                                <div className="col-md">
                                    <label className="form-label"><L>Wound photo</L></label>
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Photo of wound is available." name="woundHasPhoto" type="switch" onChange={this.onChange} />
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Wound type?" name="woundType" type="select" options={this.state.woundTypes} onChange={this.onChange} />
                                    {this.state.item.survey.woundType === 'Other' ? <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Other..." name="woundTypeOtherInfo" labelAsPlaceholder onChange={this.onChange} /> : ''}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <FormInput disabled={this.state.locked} model={this.state.item.patient} label="Wound Status" name="latestRiskTab" type="select" options={[
                                        { id: 'acute', name: 'Acute' },
                                        { id: 'chronic', name: 'Chronic' }
                                    ]} onChange={this.onChange} />
                                </div>
                            </div>
                        </Card>
                    </Tab>}
                    <Tab eventKey="treatment" title="Treatment/Hist">
                        <Card title="Treatment History">
                            <div className="row">
                                <div className="col-md">
                                    <label className="form-label">Treatments Received so far:</label>
                                    {this.state.item.survey.careStatusAssistedLiving ? <div className="d-flex">
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Name" type="text" name="careStatusAssistedLivingContact" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Phone" name="careStatusAssistedLivingContactPhone" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="careStatusAssistedLivingInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3" />
                                    </div> : ''}
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Home Health" name="careStatusHomeHealth" type="switch" onChange={this.onChange} />
                                    {this.state.item.survey.careStatusHomeHealth ? <div className="d-flex">
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Name" type="text" name="careStatusHomeHealthContact" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Phone" name="careStatusHomeHealthContactPhone" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="careStatusHomeHealthInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3" />
                                    </div> : ''}
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Hospice" name="careStatusHospice" type="switch" onChange={this.onChange} />
                                    {this.state.item.survey.careStatusHospice ? <div className="d-flex">
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Name" type="text" name="careStatusHospiceContact" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Phone" name="careStatusHospiceContactPhone" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="careStatusHospiceInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3" />
                                    </div> : ''}
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="SNF" name="careStatusSNF" type="switch" onChange={this.onChange} />
                                    {this.state.item.survey.careStatusSNF ? <div className="d-flex">
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Name" type="text" name="careStatusSNFContact" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Phone" name="careStatusSNFContactPhone" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="careStatusSNFInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3" />
                                    </div> : ''}
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="PCP" name="careStatusPCP" type="switch" onChange={this.onChange} />
                                    {this.state.item.survey.careStatusPCP ? <div className="d-flex">
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Name" type="text" name="careStatusPCPContact" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Phone" name="careStatusPCPContactPhone" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="careStatusPCPInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3" />
                                    </div> : ''}
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Other" name="careStatusOther" type="switch" onChange={this.onChange} />
                                    {this.state.item.survey.careStatusOther ? <div className="d-flex">
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Name" type="text" name="careStatusOtherContact" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Phone" name="careStatusOtherContactPhone" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3 me-2" />
                                        <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="careStatusOtherInfo" labelAsPlaceholder onChange={this.onChange} inputGroupClassName="mb-3" />
                                    </div> : ''}
                                </div>
                                <div className="col-md">
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="What are you doing now for the wound?" name="treatmentNowDescription" type="textarea" onChange={this.onChange} />
                                </div>
                            </div>
                        </Card>


                        <div className="row">
                            <div className="col-md">
                                <Card title="Medical History" className="col-md">
                                    <div className="row">
                                        <div className="col-md">
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Autoimmune" name="medicalHistoryAutoimmune" type="switch" onChange={this.onChange} />
                                            <div className="d-flex justify-content-start align-items-center">
                                                <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Cancer" name="medicalHistoryCancer" type="switch" onChange={this.onChange} />
                                                {this.state.item.survey.medicalHistoryCancer ? <div className="ms-2"><FormInput disabled={this.state.locked} model={this.state.item.survey} label="Active Cancer" name="medicalHistoryCancerActive" type="switch" onChange={this.onChange} /></div> : ''}
                                            </div>
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Cardiac Disease" name="medicalHistoryCardioDisease" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Diabetes" name="medicalHistoryDiabetes" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Incontinence" name="medicalHistoryIncontinence" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Kidney Disease" name="medicalHistoryKidneyDisease" type="switch" onChange={this.onChange} />
                                        </div>
                                        <div className="col-md">
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Lymphedema" name="medicalHistoryLymphedema" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Mobility Issues" name="medicalHistoryMobilityIssues" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Pulmonary Disease" name="medicalHistoryPulmonaryDisease" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Vascular Disease" name="medicalHistoryVascularDisease" type="switch" onChange={this.onChange} />
                                        </div>
                                    </div>
                                    <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Notes" name="medicalHistoryNotes" type="textarea" rows={4} onChange={this.onChange} />
                                </Card>
                            </div>
                            <div className="col-md">
                                <Card title="Active Medications" className="col-md">
                                    <div className="row">
                                        <div className="col-md">
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Blood Thinners" name="activeMedsBloodThinners" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Chemotherapy/Radiation" name="activeMedsRadiation" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Heart Medicines" name="activeMedsHeart" type="switch" onChange={this.onChange} />
                                        </div>
                                        <div className="col-md">
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Immunosuppresive Medicines" name="activeMedsImmunosuppresive" type="switch" onChange={this.onChange} />
                                            <FormInput disabled={this.state.locked} model={this.state.item.survey} label="Insulin Medicines" name="activeMedsInsulin" type="switch" onChange={this.onChange} />
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>

                    </Tab>

                    {this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <Tab eventKey="ivr" title="IVR">
                        {this.readyToIVR() ? <>
                            <Card title="Wound Types">
                                {this.state.woundTypes2.map(obj => <div key={obj} className="row"><div className="col"><FormInput disabled={this.state.locked} type="switch" model={this.state.selectedWoundTypes} name={obj} label={obj} onChange={obj => { this.setState({ selectedWoundTypes: this.state.selectedWoundTypes }); this.onChange(); }} /></div>

                                    {this.state.selectedWoundTypes[obj] ? <div className="col">
                                        <div className="d-flex justify-content-start align-items-center">
                                            <div style={{ maxWidth: '150px' }}>
                                                <FormInput disabled={this.state.locked} type="text" model={this.state.selectedWoundLengths} name={obj} label="L" labelAsPlaceholder onChange={() => this.onChange()} />
                                            </div>
                                            <div className="px-2"><L>X</L></div>
                                            <div style={{ maxWidth: '150px' }}>
                                                <FormInput disabled={this.state.locked} type="text" model={this.state.selectedWoundWidths} name={obj} label="W" labelAsPlaceholder onChange={() => this.onChange()} />
                                            </div>
                                            <div className="px-2"><L>X</L></div>
                                            <div style={{ maxWidth: '150px' }}>
                                                <FormInput disabled={this.state.locked} type="text" model={this.state.selectedWoundDepths} name={obj} label="D" labelAsPlaceholder onChange={() => this.onChange()} />
                                            </div>
                                            <div style={{ maxWidth: '150px' }}>
                                                <FormInput disabled={this.state.locked} type="select" model={this.state.selectedWoundUnits} name={obj} label="" labelAsPlaceholder options={this.state.units} onChange={v => this.onSelectedWoundUnitsChange(obj, v)} />
                                            </div>
                                        </div>

                                    </div> : ''}</div>)}

                                <FormInput disabled={this.state.locked} type="switch" model={this.state.extra} name="selectedWoundOther" label="Other" onChange={(obj) => {
                                    this.setState({ selectedWoundOther: obj }); if (!obj) { var extra = { ...this.state.extra }; extra.woundTypesOther = null; this.setState({ extra: extra }); }
                                }} />
                                {this.state.selectedWoundOther ? <FormInput disabled={this.state.locked} type="text" model={this.state.extra} name="woundTypesOther" label="Enter other wounds comma ',' separated" /> : ''}
                            </Card>
                            <DiagCodeSelect item={this.state.item} onChange={this.onChange} disabled={this.state.locked} />
                            <Card title="CPT Codes">
                                {this.state.cptCodes.map(obj => <div key={obj}><FormInput disabled={this.state.locked} type="switch" model={this.state.selectedCPTCodes} name={obj} label={obj} /></div>)}
                            </Card>
                            {Auth.hasRole('manager') ? <Card title="IVR">
                                <FormInput disabled={this.state.locked} model={this.state.item} name="productQCode" label="Product" type="select" options={this.state.productList} onChange={this.onAccountChange} />
                                <FormInput disabled={this.state.locked} model={this.state.item.account} name="id" label="Account" type="select" options={this.state.accountList} onChange={this.onAccountChange} />
                                <FormInput disabled={this.state.locked} model={this.state.item} name="practiceID" label="Practice" type="select" options={this.state.practiceList} onChange={this.onChange} />
                                <FormInput disabled={this.state.locked} model={this.state.item.provider} name="id" label="Provider" type="select" options={this.state.providerList} onChange={this.onChange} />
                                <div className="btn-group my-2">
                                    <button disabled={this.state.locked} type="button" className="btn btn-secondary" onClick={() => this.downloadIVR('v2')}><Icon icon="faDownload" /> <L>Download IVR</L></button>
                                    <button disabled={this.state.locked || this.state.requesting} type="button" className="btn btn-primary" onClick={() => this.requestSign()}><Icon icon="faSignature" /> <L>Request IVR Signature</L></button>
                                    <button disabled={this.state.locked} type="button" className="btn btn-success" onClick={() => this.setState({ showSendIVR: true })}><Icon icon="faPaperPlane" /> {this.state.item.status === 'IVR Sent' ? 'Resend IVR' : 'Send IVR'}</button>
                                    {this.state.item.status !== 'IVR Sent' ? <button disabled={this.state.locked} type="button" className="btn btn-primary" onClick={this.setIVRSent}><Icon icon="faCheck" /> <L>Set to IVR Sent</L></button> : ''}
                                </div>
                            </Card> : null}
                        </> : <Card title="IVR">
                            <Alert><L>To be able to render and send an IVR, the</L><strong><L>Patient Information</L></strong><L>must be filled in.</L></Alert>
                        </Card>}
                    </Tab>}
                    <Tab eventKey="documents" title="Documents">
                        <DocumentList list={this.state.item.documents} parentItem={this.state.item} edit onDocumentUpdate={() => this.load()} />
                        <MedicalRelease item={this.state.item} />
                        <RequestFormList item={this.state.item} />
                    </Tab>
                    <Tab eventKey="rating" title="Rating">
                        <Card title="Rating">
                            <p className="lead"><L>Click a star to set the rating.</L></p>
                            <Rating rating={this.state.item.rating} onChange={!this.state.locked ? v => this.setState({ item: { ...this.state.item, rating: v } }) : null} reset />
                        </Card>
                    </Tab>
                </Tabs>
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>
                    <div className="d-none">
                        <button disabled={this.state.locked} id="c-submit" type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button disabled={this.state.locked} type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(LeadsEdit);